<script>
    import {Form} from '../../../../helpers/Form/Form'
    import * as VueGoogleMaps from 'vue2-google-maps';
    import vSelect from 'vue-select';
    import StarRating from 'vue-star-rating';

    export default {
        components: {
            'google-map': VueGoogleMaps.Map,
            'google-marker': VueGoogleMaps.Marker,
            'v-select': vSelect,
            StarRating
        },
        name: "MyCourseItem",
        props: {
            courseprop: {
                type: Object
            },
            companies: null,
            sports: null
        },
        data() {
            return {
                course: {},
                form: new Form({}),
                duplicatedCourse: {
                    'company': null,
                    'sport': null,
                    'name': '',
                },
                types: ['geocode'],
                open: false,
                actionButton: {
                    text: 'Opzioni corso'
                }
            }
        },
        created() {
            this.course = this.courseprop;
        },
        watch: {
            courseprop(newVal, oldVal) {
                this.course = newVal;
            }
        },
        computed: {
            countReservations() {
                if (this.course.hasOwnProperty('reservations')) {
                    return this.course.reservations.length
                }
                return 0
            }
        },
        methods: {
            hasLowConversionRate(){
               let conversionRate = 0;
               if (this.course.hasOwnProperty('reservations')) {
                   conversionRate = this.course.reservations.length / this.course.total_views;
                }
               return conversionRate < 0.2
            },
            getSelectSportId(courseId) {
                return 'select_sport' + courseId
            },
            getSelectPlaceId(courseId) {
                return 'duplicate_course_map' + courseId
            },
            getModalId(courseId) {
                return 'duplicate_modal' + courseId
            },
            openDuplicateModal() {
                this.$bus.$emit('open-duplicate-modal', this.course);
            },
            onDisablePromotion(course) {
                this.form
                    .submit('put', `${window.baseUrl}/corsi/${course.slug}/update-promotion`)
                    .then(response => location.reload())
            },
            getActiveCourseId(id) {
                return 'active-course-' + id
            },
            remove(course) {
                let self = this;
                bootbox.confirm({
                    message: "<span class='fw-600'>Sei sicuro di voler eliminare questo corso?</span>" + "<br>" + "<span class='font-14'>Eliminandolo verrà rimosso dai tuoi corsi definitivamente e non sarà più visibile su Orangogo. Potrai sempre ricrearlo quando vuoi.</span>",
                    buttons: {
                        confirm: {
                            label: 'Elimina corso',
                            className: 'btn btn-white'
                        },
                        cancel: {
                            label: 'Annulla',
                            className: 'btn btn-white-secondary'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            axios({
                                method: 'delete',
                                url: '/courses/' + course.id,
                            }).then((response) => {
                                self.$bus.$emit('delete-course', course);
                                window.alerts.success('Corso eliminato correttamente');
                            }).catch((error) => {
                                window.alerts.error('Operazione Fallita');
                            });
                        }
                    },
                })
                $('.modal-dialog').addClass('modal-dialog-centered');
            },
            toggleActivation(course) {
                if (!course.is_complete) {
                    course.is_active = false;
                    bootbox.confirm({
                        message: "Questo corso è incompleto e non può essere attivato<br>Vuoi completarlo adesso?",
                        buttons: {
                            cancel: {
                                label: 'Chiudi',
                                className: 'btn btn-white-secondary'
                            },
                            confirm: {
                                label: 'Completa Corso',
                                className: 'btn-white'
                            }
                        },
                        callback: function (result) {
                            if (result) {
                                location.href = '/corsi/' + course.slug + '/edit';
                            }
                        }
                    });
                }
                else {
                    if (course.is_active) {
                        bootbox.confirm({
                            message: "<span class='fw-600'>Vuoi disattivare questo corso?</span> <br> <span class='font-14'>Disattivandolo non sarà più visibile online su Orangogo.\n" +
                            "Potrai riattivarlo in qualsiasi momento cliccando su “Attiva”</span>",
                            buttons: {
                                cancel: {
                                    label: 'Annulla',
                                    className: 'btn btn-white-secondary'
                                },
                                confirm: {
                                    label: 'Disattiva corso',
                                    className: 'btn-white'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    axios({
                                        method: 'put',
                                        url: '/courses/' + course.id + '/update-course-status',
                                        data: {
                                            is_active: !course.is_active
                                        }
                                    }).then((response) => {
                                        course.is_active = response.data.is_active;
                                    }).catch((error) => {
                                        this.$emit('init-error', 'Active failed');
                                    });
                                }
                            }
                        });
                        $('.modal-dialog').addClass('modal-dialog-centered');
                    } else {
                        axios({
                            method: 'put',
                            url: '/courses/' + course.id + '/update-course-status',
                            data: {
                                is_active: !course.is_active
                            }
                        }).then((response) => {
                            course.is_active = response.data.is_active;
                        }).catch((error) => {
                            this.$emit('init-error', 'Active failed');
                        });
                    }
                }
            },
            goToCoursePage(course) {
                return window.open(`/corsi/${course.slug}`)
            },
            goToCourseEditPage(course) {
                return window.open(`/corsi/${course.slug}/edit`)
            },
            goToCourseEditSmartPage(course) {
                $("#course-smart-modal").modal('show')

                this.$bus.$emit('courses.edit', {course})
            },
            onPromotion(course) {
                this.$bus.$emit('update-promotion', course)
            },
            search: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: '/sports/search?q=' + search
                }).then((response) => {
                    vm.sports = response.data.sports;
                    loading(false);
                }).catch((error) => {
                    vm.message = 'Error';
                });
            }),
            toggleActions(){
                this.open = !this.open;
                this.actionButton.text = this.open ? 'Chiudi' : 'Opzioni corso';
            },
            isOpen(){
                return this.open;
            }

        },
        directives: {
            selectsport: {
                twoWay: true,
                bind:
                    function (el, binding, vnode) {
                        $(el).select2()
                            .on("select2:select", function (e) {
                                vnode.context.duplicatedCourse.sport = $(el).val();
                            }.bind(this));
                    }

                ,
                update: function (el) {
                    $(el).trigger("change");
                }
            }
            ,
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/MyCourseItem.vue